import React from 'react'

function UpdateClass() {
  return (
    <div>UpdateClass</div>
  )
}

export default UpdateClass